import { createSlice } from "@reduxjs/toolkit";
import { BuscaCentroCustoModel } from "../../../models/centroCusto/buscaCentroCustoModel";
import { CentroCustoDtoModel } from "../../../models/centroCusto/centroCustoDtoModel";
import { buscarCentroCusto } from "../../../services/centroCustoService";
import { resetAll } from "../../actions/actions";

export interface CentroCustoState {
  //buscar centro custo
  loading: boolean;
  busca: BuscaCentroCustoModel;
  list: CentroCustoDtoModel[];
  entity: CentroCustoDtoModel;
  //internal
  modalCadastrar: boolean;
  modalDeletar: boolean;
}

const initialState: CentroCustoState = {
  //buscar centro custo
  loading: false,
  busca: {
    pesquisar: null,
    receita: null,
    despesa: null,
    ativo: null,
  },
  list: [],
  entity: {} as CentroCustoDtoModel,
  //internal
  modalCadastrar: false,
  modalDeletar: false,
};

export const centroCustoSlice = createSlice({
  name: "centroCusto",
  initialState,
  reducers: {
    //buscar centro custo
    setBuscaCentroCusto: (state, action) => {
      state.busca = action.payload;
    },
    setEntityCentroCusto: (state, action) => {
      state.entity = action.payload;
    },
    //internal
    setModalCadastrarCentroCusto: (state, action) => {
      state.modalCadastrar = action.payload;
    },
    setModalDeletarCentroCusto: (state, action) => {
      state.modalDeletar = action.payload;
    },
  },
  extraReducers: (builder) => {
    //resetar estados
    builder.addCase(resetAll, () => initialState);

    //buscar centro custo
    builder.addCase(buscarCentroCusto.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(buscarCentroCusto.fulfilled, (state, action) => {
      state.list = action.payload;
      state.loading = false;
    });
    builder.addCase(buscarCentroCusto.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

export const {
  //buscar centro custo
  setBuscaCentroCusto,
  setEntityCentroCusto,
  //internal
  setModalCadastrarCentroCusto,
  setModalDeletarCentroCusto,
} = centroCustoSlice.actions;

export default centroCustoSlice.reducer;
